// extracted by mini-css-extract-plugin
export default {"link":"UiLink_link","icon":"UiLink_icon"};